var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade-fast" } }, [
    _vm.novel
      ? _c(
          "div",
          [
            _c("div", { staticClass: "novel-detail" }, [
              _c("div", { staticClass: "info-img" }, [
                _c(
                  "div",
                  {
                    ref: "coverImageWrapper",
                    staticClass: "cover-image-wrapper",
                  },
                  [
                    _c("image-view", {
                      key: _vm.coverImageVersion,
                      staticClass: "novel-cover-image",
                      attrs: {
                        src: _vm.imageKey,
                        placeholder: "/img/placeholders/novel.png",
                      },
                    }),
                    !_vm.hasCoverImage
                      ? _c(
                          "button",
                          {
                            staticClass: "cover-image-edit-button",
                            attrs: {
                              type: "button",
                              disabled: _vm.isCoverImageSaving,
                              "aria-label": _vm
                                .$t("novelDetail.changeCoverImage")
                                .toString(),
                            },
                            on: { click: _vm.onClickChangeCoverImage },
                          },
                          [
                            _c("IconImagePlus", {
                              staticClass: "cover-image-edit-icon",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ],
                          1
                        )
                      : [
                          _c(
                            "button",
                            {
                              ref: "coverImageMenuButton",
                              staticClass: "cover-image-edit-button",
                              attrs: {
                                type: "button",
                                disabled: _vm.isCoverImageSaving,
                                "aria-haspopup": "true",
                                "aria-expanded": _vm.isCoverImageMenuOpen
                                  ? "true"
                                  : "false",
                                "aria-label": _vm
                                  .$t(
                                    "novelDetail.coverImageSetting.menuButtonLabel"
                                  )
                                  .toString(),
                              },
                              on: { click: _vm.toggleCoverImageMenu },
                            },
                            [
                              _c("IconPencil", {
                                staticClass: "cover-image-edit-icon",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ],
                            1
                          ),
                          _vm.isCoverImageMenuOpen
                            ? _c(
                                "div",
                                {
                                  ref: "coverImageMenu",
                                  staticClass: "cover-image-menu-popover",
                                  attrs: { role: "menu" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "cover-image-menu-item",
                                      attrs: {
                                        type: "button",
                                        role: "menuitem",
                                        disabled: _vm.isCoverImageSaving,
                                      },
                                      on: {
                                        click: _vm.onClickChangeCoverImage,
                                      },
                                    },
                                    [
                                      _c("IconImagePlus", {
                                        staticClass:
                                          "cover-image-menu-item-icon",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "novelDetail.coverImageSetting.changeImage"
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "cover-image-menu-item cover-image-menu-item-danger",
                                      attrs: {
                                        type: "button",
                                        role: "menuitem",
                                        disabled: _vm.isCoverImageSaving,
                                      },
                                      on: {
                                        click: _vm.onClickDeleteCoverImage,
                                      },
                                    },
                                    [
                                      _c("IconTrash", {
                                        staticClass:
                                          "cover-image-menu-item-icon",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "novelDetail.coverImageSetting.deleteImage"
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                  ],
                  2
                ),
                _c("div", { staticClass: "genre-category-card" }, [
                  _c("div", { staticClass: "genre-category-row" }, [
                    _c("h3", { staticClass: "genre-category-label" }, [
                      _vm._v(_vm._s(_vm.$t("novelDetail.categoryLabel"))),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "genre-category-edit-button",
                        attrs: {
                          type: "button",
                          disabled: _vm.isGenreCategorySaving,
                          "aria-label": _vm
                            .$t("novelDetail.editGenreCategory")
                            .toString(),
                        },
                        on: { click: _vm.onClickEditGenreCategory },
                      },
                      [
                        _c("IconPencil", {
                          staticClass: "genre-category-edit-icon",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "genre-category-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.genreName ||
                          _vm.$t("novelDetail.genreCategoryUnset")
                      )
                    ),
                  ]),
                  _c("h3", { staticClass: "genre-category-label" }, [
                    _vm._v(_vm._s(_vm.$t("novelDetail.genreLabel"))),
                  ]),
                  _vm.categoryNames.length > 0
                    ? _c(
                        "div",
                        { staticClass: "category-pills" },
                        _vm._l(_vm.categoryNames, function (item) {
                          return _c(
                            "span",
                            { key: item.id, staticClass: "category-pill" },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        0
                      )
                    : _c("div", { staticClass: "genre-category-value" }, [
                        _vm._v(
                          _vm._s(_vm.$t("novelDetail.genreCategoryUnset"))
                        ),
                      ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "info-txt" },
                [
                  _c(
                    "div",
                    {
                      ref: "workStatusWrapper",
                      staticClass: "work-status-wrapper",
                    },
                    [
                      _c(
                        "button",
                        {
                          ref: "workStatusButton",
                          staticClass: "work-status-button",
                          style: _vm.workStatusButtonStyle,
                          attrs: {
                            type: "button",
                            disabled: _vm.isWorkStatusSaving,
                            "aria-haspopup": "true",
                            "aria-expanded": _vm.isWorkStatusMenuOpen
                              ? "true"
                              : "false",
                          },
                          on: { click: _vm.toggleWorkStatusMenu },
                        },
                        [
                          _c("span", { staticClass: "work-status-name" }, [
                            _vm._v(_vm._s(_vm.workStatusName)),
                          ]),
                          _c("IconChevronDown", {
                            staticClass: "work-status-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ],
                        1
                      ),
                      _vm.isWorkStatusMenuOpen
                        ? _c(
                            "div",
                            {
                              ref: "workStatusMenu",
                              staticClass: "work-status-menu-popover",
                              attrs: { role: "menu" },
                            },
                            _vm._l(
                              _vm.translatedWorkStatusList,
                              function (item) {
                                return _c(
                                  "button",
                                  {
                                    key: item.id,
                                    staticClass: "work-status-menu-item",
                                    attrs: {
                                      type: "button",
                                      role: "menuitemradio",
                                      disabled: _vm.isWorkStatusSaving,
                                      "aria-checked":
                                        _vm.currentWorkStatusId === item.id
                                          ? "true"
                                          : "false",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onClickWorkStatus(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm.currentWorkStatusId === item.id
                                      ? _c("IconCheck", {
                                          staticClass:
                                            "work-status-menu-item-check",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _c("span", {
                                          staticClass:
                                            "work-status-menu-item-check-spacer",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                    _c("span", [_vm._v(_vm._s(item.name))]),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c("div", { staticClass: "field-header" }, [
                    _c("h2", [_vm._v(_vm._s(_vm.$t("novelDetail.title")))]),
                    _c("span", { staticClass: "counter" }, [
                      _vm._v(_vm._s(_vm.titleCounter)),
                    ]),
                  ]),
                  _c("text-field", {
                    staticClass: "detail-title-field",
                    attrs: {
                      label: _vm.$t("novelDetail.title").toString(),
                      maxlength: _vm.titleMaxLength,
                      "sync-value": "",
                    },
                    on: { input: _vm.onChangeTitleOrDescription },
                    nativeOn: {
                      compositionstart: function ($event) {
                        return _vm.onCompositionStart("title")
                      },
                      compositionend: function ($event) {
                        return _vm.onCompositionEnd("title")
                      },
                    },
                    model: {
                      value: _vm.editableTitle,
                      callback: function ($$v) {
                        _vm.editableTitle = $$v
                      },
                      expression: "editableTitle",
                    },
                  }),
                  _c("div", { staticClass: "field-header" }, [
                    _c("h2", [_vm._v(_vm._s(_vm.$t("novelDetail.synopsis")))]),
                    _c("span", { staticClass: "counter" }, [
                      _vm._v(_vm._s(_vm.descriptionCounter)),
                    ]),
                  ]),
                  _c("text-field", {
                    staticClass: "detail-description-field",
                    attrs: {
                      label: _vm.$t("novelDetail.synopsis").toString(),
                      rows: 15,
                      maxlength: _vm.descriptionMaxLength,
                    },
                    on: { input: _vm.onChangeTitleOrDescription },
                    nativeOn: {
                      compositionstart: function ($event) {
                        return _vm.onCompositionStart("description")
                      },
                      compositionend: function ($event) {
                        return _vm.onCompositionEnd("description")
                      },
                    },
                    model: {
                      value: _vm.editableDescription,
                      callback: function ($$v) {
                        _vm.editableDescription = $$v
                      },
                      expression: "editableDescription",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "content" }, [
              _c("hr", { staticClass: "dotted light-gray" }),
              _c(
                "div",
                { staticClass: "assosiate-container flex flex-column" },
                [
                  _c("div", [
                    _vm.novelIdFromNolaNovel
                      ? _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("novelDetail.nolaNovel.updateTitle"))
                          ),
                        ])
                      : _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("novelDetail.nolaNovel.postTitle"))
                          ),
                        ]),
                  ]),
                  _vm.novelIdFromNolaNovel
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("novelDetail.nolaNovel.updateDescription")
                          )
                        ),
                      ])
                    : [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("novelDetail.nolaNovel.description"))
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("novelDetail.nolaNovel.editorInfo"))
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("novelDetail.nolaNovel.editorBenefit")
                            )
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("novelDetail.nolaNovel.privacyNote"))
                          ),
                        ]),
                      ],
                  _c("div", { staticClass: "mt-1 flex flex-row gap-harf" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn post bold pointer",
                        on: {
                          click: function ($event) {
                            return _vm.postToNolaNovelButtonClick(true)
                          },
                        },
                      },
                      [
                        _vm.novelIdFromNolaNovel
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("novelDetail.nolaNovel.updateButton")
                                )
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("novelDetail.nolaNovel.postButton")
                                )
                              ),
                            ]),
                      ]
                    ),
                    !_vm.novelIdFromNolaNovel
                      ? _c(
                          "div",
                          {
                            staticClass: "btn link bold pointer",
                            on: {
                              click: function ($event) {
                                return _vm.postToNolaNovelButtonClick(false)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("novelDetail.nolaNovel.linkButton")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.novelIdFromNolaNovel
                      ? _c(
                          "div",
                          {
                            staticClass: "btn link bold pointer",
                            on: { click: _vm.delinkNolaNovelButtonClick },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("novelDetail.nolaNovel.unlinkButton")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                2
              ),
              _c("hr", { staticClass: "dotted light-gray" }),
              _c("div", { staticClass: "delete-container flex flex-column" }, [
                _c("h3", [_vm._v(_vm._s(_vm.$t("novelDetail.delete.title")))]),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("novelDetail.delete.description"))),
                ]),
                _c("div", { staticClass: "mt-1 flex flex-row gap-harf" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn delete bold pointer",
                      attrs: { type: "button", disabled: _vm.isDeleteDisabled },
                      on: { click: _vm.deleteButtonClick },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("novelDetail.delete.deleteButton")) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm.showFirstWorkStatusHighlight
              ? _c("Onboarding", {
                  attrs: {
                    targetSelector: ".work-status-wrapper .work-status-button",
                    message: `<div style='font-size:var(--font-size-md); margin-top:10px; margin-bottom:-12px; margin-right:55px'>${_vm.$t(
                      "novelDetail.workStatusOnboardingMessage"
                    )}</div>`,
                    canOutsideClick: true,
                    tooltipPosition: "bottom-right",
                    maxWidth: "460px",
                    tooltipPadding: "14px 20px",
                    tooltipBorderRadius: "15px",
                  },
                  on: { "onboarding-finished": _vm.closeWorkStatusHighlight },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }